import { render, staticRenderFns } from "./PensionUnitSelectionEdit.vue?vue&type=template&id=61a6533b&scoped=true&"
import script from "./PensionUnitSelectionEdit.vue?vue&type=script&lang=ts&"
export * from "./PensionUnitSelectionEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a6533b",
  null
  
)

export default component.exports